import Axios from 'axios'
import config from '../../config'
import { transformDisponibility } from '../../utilities/dates'
import { InquiryPaths } from '../inquiries'
import { toInquiry } from './adapters'

export const create = async ({
  address,
  description,
  disponibilities,
  invoicing,
  selected,
  code,
  appliedCouponCodeId,
  leadFunnel,
  attribution
}) => {
  // we can't have nothing but visits for maintenance
  const URL = `${config.baseURL}${config.apiURL}customers/${InquiryPaths.MAINTENANCE}${InquiryPaths.VISIT}`
  const response = await Axios.post(URL, {
    address,
    description,
    disponibilities: disponibilities
      .filter((d) => d.date)
      .map((d) => transformDisponibility(d.daytime, d.date)),
    invoicingAddress: invoicing,
    selected,
    zipCode: code,
    appliedCouponCodeId,
    leadFunnel,
    attribution
  })
  return response.data
}

export const get = async ({ id, type }) => {
  const URL = `${config.baseURL}${config.apiURL}customers/${InquiryPaths.MAINTENANCE}${InquiryPaths[type] || ''}/${id}`
  const response = await Axios.get(URL)
  return toInquiry(type)(response.data)
}

export const signMandate = async ({ id }) => {
  const URL = `${config.baseURL}${config.apiURL}payment/sdd/sign?inquiryId=${id}`
  const response = await Axios.post(URL)
  window.location.replace(response.data.redirect)
}

export const accept = async ({ id, proposal, asAdmin, paymentType }) => {
  let URL = `${config.baseURL}${config.apiURL}customers/maintenance/realisations/${id}/accept/${proposal}`
  if (asAdmin) {
    URL = `${URL}?isAdmin=${!!asAdmin}`
    if (paymentType) {
      URL = `${URL}&paymentType=${paymentType}`
    }
  }
  await Axios.post(
    URL,
    undefined,
    {
      params: {
        isAdmin: !!asAdmin,
        paymentType: paymentType || undefined
      }
    }
  )
}

export const close = async ({ id }) => {
  const URL = `${config.baseURL}${config.apiURL}customers/${InquiryPaths.MAINTENANCE}${InquiryPaths.REALISATION}/${id}/close`
  const response = await Axios.post(URL)
  return toInquiry(InquiryPaths.MAINTENANCE)(response.data)
}



// WEBPACK FOOTER //
// ./src/api/inquiries/maintenance.js